import React from "react"
import PropTypes from "prop-types"
import loadable from "@loadable/component"
import { compareResponsiveSizes } from "./utils"
import { AdSlot } from "react-dfp"
import { gamActive, gamIsDev, gamIsProduction, gamIsSamples } from "./utils"
const DummySlot = loadable(() => import("./dummy-slot"))

// React DFP Documentation: https://react-dfp.surge.sh/

const getAdSlotProps = adUnitConfiguration => {
  const output = {}
  const sizes = adUnitConfiguration.adUnitSizes.map(el => [
    el.size.width,
    el.size.height,
  ])
  /* Generate ad unit name:
     21775873519/cinema2dayit/bufox-cinema2day.it-wpc  */
  // const networkCode = adUnitConfiguration.network_code
  let parentPath = adUnitConfiguration.parentPath.reduce((prev, current) => {
    return current.name.startsWith("ca-pub")
      ? prev
      : `${prev}/${current.adUnitCode}`
  }, "")
  if (parentPath.startsWith("/")) {
    parentPath = parentPath.slice(1)
  }
  const adUnitCode = adUnitConfiguration.adUnitCode
  output.adUnit = `${parentPath}/${adUnitCode}`

  output.sizes = sizes
  if (adUnitConfiguration.responsive) {
    // at first, we should sort the sizes.
    const sortedSizes = Object.values(adUnitConfiguration.responsive)
      .sort(compareResponsiveSizes)
      .reverse()
    const sizeMapping = sortedSizes.map(el => {
      return {
        viewport: [el.screen.width, el.screen.height],
        sizes: Object.values(el.sizes).map(el => [
          el.size.width,
          el.size.height,
        ]),
      }
    })
    output.sizeMapping = sizeMapping
  }
  return output
}

const AdSlotWithDevSupport = ({ adUnitConfiguration, adSlotId, className }) => {
  return (
    gamActive() && (
      <div className={className}>
        {gamIsDev() ? (
          <DummySlot adUnitConfiguration={adUnitConfiguration}></DummySlot>
        ) : gamIsProduction() ? (
          <AdSlot
            slotId={adSlotId}
            {...getAdSlotProps(adUnitConfiguration)}
          ></AdSlot>
        ) : gamIsSamples() ? (
          <AdSlot
            {...getAdSlotProps(adUnitConfiguration)}
            slotId={adSlotId}
            adUnit="Travel/Europe/France/Paris"
          ></AdSlot>
        ) : null}
      </div>
    )
  )
}

AdSlotWithDevSupport.propTypes = {
  adUnitConfiguration: PropTypes.object,
  className: PropTypes.string,
  adSlotId: PropTypes.string,
}

export default AdSlotWithDevSupport
